
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "commitHash": "a8af7336e7400f03b091c8b19373ecb2f49aef8e",
    "version": "11.1.0-stablelib.0"
};
/* tslint:enable */
